var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#00508C"}}),_c('line',{attrs:{"x1":"17","x2":"7","y1":"12","y2":"12","stroke":"#FFF","stroke-linecap":"round","stroke-width":"3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }